import * as types from "./type.js";
export default {
  [types.AUTH_USER_INFO]: {
    wstoken: "",
    firstname: "",
    lastname: "",
    username: "",
    userid: "",
    userpictureurl: "",
    dateTime: ""
  },
  [types.COUNT_STATE]: 0
};
